export const WEBMAIL_DOMAINS = [
  'gmail',
  'outlook',
  'hotmail',
  'live',
  'msn',
  'yahoo',
  'ymail',
  'rocketmail',
  'icloud',
  'me',
  'mac',
  'aol',
  'protonmail',
  'pm',
  'zoho',
  'comcast',
  'xfinity',
  'sbcglobal',
  'att',
  'verizon',
  'charter',
  'spectrum',
  'cox',
  'rogers',
  'bell',
  'telus',
];

export const PRIMARY_INDUSTRY_GROUP = [
  'Media',
  'Movies & Entertainment',
  'Broadcasting',
];

export const SECONDARY_INDUSTRY_GROUP = [
  'Publishing',
  'Advertising',
  'Education Services',
  'Public Relations',
  'Internet',
  'Hotels, Restaurants & Leisure',
  'Consulting',
  'Communications',
  'Integrated Telecommunication Services',
  'Wireless Telecommunication Services',
];
